import { render, staticRenderFns } from "./EstimationItem.vue?vue&type=template&id=87b7ac8a&scoped=true&"
import script from "./EstimationItem.vue?vue&type=script&lang=js&"
export * from "./EstimationItem.vue?vue&type=script&lang=js&"
import style0 from "./EstimationItem.vue?vue&type=style&index=0&id=87b7ac8a&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "87b7ac8a",
  null
  
)

export default component.exports